import { useEffect } from 'react';

import { EVENT_TITLE_HEIGHT, ZOOM_CONTROL_HEIGHT } from '../constants';

export const useVideoShareLayoutScale = () => {
  useEffect(() => {
    const updateScale = () => {
      const vh = window.innerHeight;
      // This is not 100% accurate.
      // In order to get the exact value we would need to wait for the
      // zoom meeting to load with the video share layout and it makes
      // things an order of magnitude more complex for little gain.
      const scale = (vh - EVENT_TITLE_HEIGHT - ZOOM_CONTROL_HEIGHT) / vh;

      document.documentElement.style.setProperty(
        '--video-share-layout-scale',
        scale.toString(),
      );
    };

    // Update on load and resize
    updateScale();
    window.addEventListener('resize', updateScale);

    return () => {
      window.removeEventListener('resize', updateScale);
    };
  }, []);
};
